"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const Timer = ({ callStartTime, }) => {
    const [timeInSeconds, setTimeInSeconds] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        var _a;
        if (callStartTime) {
            const callStartTimeInNanoSeconds = ((_a = callStartTime === null || callStartTime === void 0 ? void 0 : callStartTime.seconds) === null || _a === void 0 ? void 0 : _a.low) || 0 + ((callStartTime === null || callStartTime === void 0 ? void 0 : callStartTime.nanos) || 0) / 1000000000;
            const timer = window.setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
                const currentTimeInNanoSeconds = new Date().getTime() / 1000;
                setTimeInSeconds(convertTimeStampToReadableString(currentTimeInNanoSeconds - callStartTimeInNanoSeconds));
            }), 1000);
            return () => window.clearInterval(timer);
        }
        else
            return;
    }, [timeInSeconds, callStartTime]);
    return ((0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ bold: true, size: "medium", color: "dark", style: { marginRight: '12px', marginLeft: '4px', minWidth: '28px' }, "data-testid": "in-call-timer" }, { children: timeInSeconds || '0:00' })));
};
exports.Timer = Timer;
const convertTimeStampToReadableString = (secondsElapsed) => {
    const minutes = Math.floor(secondsElapsed / 60);
    const seconds = Math.floor(secondsElapsed % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};
//# sourceMappingURL=timer.js.map